import UrgentCampaigns from './UrgentCampaigns.router';
export { default as urgentCampaignsRoutes } from './routes';

export default UrgentCampaigns;
